import { NgModule } from '@angular/core';
import { KarirV2RoutingModule } from './karir-v2.routing.module';

@NgModule({
  imports: [KarirV2RoutingModule],
})
export class KarirV2Module {}
